var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('student-list',{on:{"selected":function($event){_vm.selected = $event}}})],1),_c('v-flex',{attrs:{"xs12":"","sm7":"","md7":""}},[(_vm.selected)?_c('student-card',{attrs:{"student":_vm.selected}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }